export class ProductUpdate {
	constructor(
		public readonly id: string,
		public readonly priceTypeForCalculation: string | null,
		public readonly packageSizeForCalculation: number | null,
		public readonly packageSizeForSingleUnit: number | null,
		public readonly selected: boolean,
		public readonly amountOfSubstanceInUnit: number | null
	) {}
}
